exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".text-right{text-align:right}", "", {"version":3,"sources":["/var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/event-list/event-list-financial-table/event-list-financial.component.css"],"names":[],"mappings":"AACA,YACE,gBAAkB,CACnB","file":"event-list-financial.component.css","sourcesContent":["\n.text-right {\n  text-align: right;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/event-list/event-list-financial-table/event-list-financial.component.css
// module id = 8mhJ
// module chunks = 0